import React, { VFC } from "react"
import ReactModal from "react-modal"

type Props = {
  isOpen: boolean
  closeModal: () => void
  children: React.ReactNode
}

const Modal: VFC<Props> = ({ isOpen, closeModal, children }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Example Modal"
      ariaHideApp={false}
      className="fixed w-4/5 px-5 py-8 text-center transform -translate-x-1/2 -translate-y-1/2 bg-white rounded shadow top-1/2 left-1/2 md:w-96"
      overlayClassName="fixed top-0 left-0 right-0 bottom-0 bg-opacity-30 bg-black z-20"
    >
      {children}
    </ReactModal>
  )
}

export default Modal
